import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import getEnv from 'utils/getEnv';

const applicationId = getEnv('REACT_APP_DATADOG_APPLICATION_ID');
const clientToken = getEnv('REACT_APP_DATADOG_CLIENT_TOKEN');

/**
 * List of URLs to trace
 * Env. variables can be undefined for TS so adding this security check
 */
const tracingUrls = [
  getEnv('REACT_APP_ROOT_URL'), // Prose API
  // Add more URLs here as needed
].filter(Boolean);

const initDatadog = () => {
  if (getEnv('REACT_APP_ENV') !== 'test' && applicationId && clientToken) {
    datadogRum.init({
      applicationId,
      clientToken,
      site: getEnv('REACT_APP_DATADOG_SITE'), // refers to the Datadog site parameter of your organization, see https://docs.datadoghq.com/getting_started/site/

      service: 'prose-www', // the service name for your application
      env: getEnv('REACT_APP_ENV'),
      version: getEnv('REACT_APP_VERSION_WWW'),
      allowedTracingUrls: tracingUrls, // specify URLs to trace

      // trackingConsent: 'granted', // user tracking consent for GDPR
      trackUserInteractions: true, // enables automatic collection of users actions
      trackResources: true, // enables collection of resource events
      trackLongTasks: true, // enables collection of long task events
      trackViewsManually: false, // debug data sending

      // to protect PII
      defaultPrivacyLevel: 'mask', // use data-dd-privacy="allow" on an HTML element to override
      enablePrivacyForActionName: true, // for buttons names and attributes, image alt, etc

      sessionSampleRate: Number(getEnv('REACT_APP_DATADOG_SESSION_SAMPLE_RATE')),
      sessionReplaySampleRate: Number(getEnv('REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE')),

      plugins: [reactPlugin({ router: false })],
    });
  }
};

export default initDatadog;
